export default __webpack_public_path__ + "static/media/pop1.1ec0da4d.png";